/**
 * DevExtreme (esm/__internal/scheduler/constants.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const LIST_ITEM_DATA_KEY = "dxListItemData";
export const LIST_ITEM_CLASS = "dx-list-item";
export const APPOINTMENT_SETTINGS_KEY = "dxAppointmentSettings";
export const VERTICAL_GROUP_ORIENTATION = "vertical";
export const HORIZONTAL_GROUP_ORIENTATION = "horizontal";
export const VERTICAL_VIEW_TYPES = ["day", "week", "workWeek"];